import { createGlobalStyle } from 'styled-components';

export const GlobalAlertsStyled = createGlobalStyle`
    .alert {
        position: relative;
        padding: 16px;
        margin-bottom: 1rem;
        border: 1px solid transparent;
        border-radius: 16px;

        > svg {
            float: left;

            + span {
                display: block;
                padding-left: 2em;
            }
        }
    }
    
    .alert-lg {
        padding: 1.5rem;
    }

    .alert-warning {
        color: #FF8F00;
        background-color: rgba(255, 143, 0, 0.1);
        border-color: transparent;
    }

    .alert-success {
        color: #54EEAB;
        background-color: rgba(20, 198, 121, 0.2);
        border: 1px solid #14C679;
    }
    
    .alert-info {
        color: #FFFFFF;
        background: #42456C;
    }
    
    .alert-info-outside {
        color: #FFFFFF;
        background: none;
    }
`;